module.exports = __webpack_public_path__ + "img/building-office-6.30fb77ba.svg";